import SignUp from './SignUp.vue';
import store from '@/store';
import authentication from '@/authentication';

const routes = [
  {
    path: '/sign-up/:dealerNumber([^/]*)?/:userId([^/]*)?/:firstName([^/]*)?/:lastName([^/]*)?',
    name: 'SignUp',
    component: SignUp,
    meta: {
      isPublic: true,
    },
    async beforeEnter(to, from, next) {
      if (store['vue-persist-patch-delay']) {
        await store['vue-persist-patch-delay'];
      }

      const actions = [];

      if (to.params.dealerNumber) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setDealerNumber`,
            to.params.dealerNumber
          )
        );
      }
      if (to.params.userId) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setUserId`,
            to.params.userId
          )
        );
      }
      if (to.params.firstName) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setFirstName`,
            to.params.firstName
          )
        );
      }
      if (to.params.lastName) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setLastName`,
            to.params.lastName
          )
        );
      }

      Promise.all(actions).then(next).catch(next);
    },
  },
];

export default routes;
